// extracted by mini-css-extract-plugin
export default {"actionBtn":"Update_actionBtn__pK6a2","confirm":"Update_confirm__JOlKS","reject":"Update_reject__80XqJ"};